import React, { FC } from 'react'
import styles from 'styles/components/template.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { push } from 'connected-react-router'
import { FirebaseTimestamp, db } from 'firebase/index'
import { State } from 'index'
import { BlueButton, NavButton } from 'components/Button'
import { SelectBox } from 'components/Form'
import { FormLabel } from 'components/Label'
import { Description, MainHeadline } from 'components/Typography'
import { Spacer } from 'components/Utility'
import { useSelect } from 'hooks/form'
import { getPointCard } from 'reducks/pointCard/selectors'
import { getBrandRef } from 'reducks/auth/selectors'
import { fetchPointCardCodeForInStore, setPointCardCode } from 'repos/pointCard/pointCardCode'

const PointCardCodeTemplate: FC = () => {
  const dispatch = useDispatch()
  const brandRef = useSelector((state: State) => getBrandRef(state))
  const pointCard = useSelector((state: State) => getPointCard(state))
  const { state: grantPoint, handleState: handleGrantPoint } = useSelect<string>('1')

  const grantPoints = Array.from({ length: 100 }, (_, i) => ({ label: `${i + 1}pt`, value: `${i + 1}` }))

  const handleShowQrCodeInStore = async () => {
    const now = FirebaseTimestamp.now()
    if (!pointCard) return
    const pointCardCodeForInStore = await fetchPointCardCodeForInStore(pointCard.ref.id)
    const ref = pointCardCodeForInStore
      ? db
          .collection('point_cards')
          .doc(pointCard.ref.id)
          .collection('point_card_codes')
          .doc(pointCardCodeForInStore.code)
      : db.collection('point_cards').doc(pointCard.ref.id).collection('point_card_codes').doc()
    await setPointCardCode({
      ref,
      brand_ref: brandRef,
      point_card_ref: pointCard.ref,
      name: pointCardCodeForInStore?.name ?? '',
      code: pointCardCodeForInStore?.code ?? ref.id,
      points: parseInt(grantPoint),
      is_in_store: true,
      created_at: pointCardCodeForInStore?.created_at ?? now,
      updated_at: now,
    })
    dispatch(push('/point_card/code/in_store'))
  }

  return (
    <div className={styles.standard}>
      <Spacer size={40} />
      <MainHeadline headline={'ポイントを付与する'} />
      <Spacer size={20} />
      <Description
        description={'お客さまへ画面を見せてポイントを付与する場合、\n「QRコードを表示する」をクリックしてください。'}
      />
      <Spacer size={20} />
      <FormLabel label={'付与するポイント'} required={false} />
      <Spacer size={20} />
      <SelectBox options={grantPoints} select={handleGrantPoint} value={grantPoint} />
      <Spacer size={12} />
      <BlueButton label={'QRコードを表示する'} onClick={handleShowQrCodeInStore} size={'medium'} type={'main'} />
      <Spacer size={24} />
      <MainHeadline headline={'QRコードを印刷する'} />
      <Spacer size={20} />
      <Description
        description={
          '店頭にQRコードを設置するなど、事前に定めたポイントを付与するQRコードを作成する場合は、「QRコードを印刷する」をクリックしてください。'
        }
      />
      <Spacer size={40} />
      <BlueButton
        label={'QRコードを印刷する'}
        onClick={() => dispatch(push('/point_card/code/list'))}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={24} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/'} />
      <Spacer size={40} />
    </div>
  )
}

export default PointCardCodeTemplate
